import storage from '../../../hooks/useStorage/useStorage';

export const getNameWithTeamId = (name: string, customTeamId?: string) => {
  const teamId = customTeamId || storage.getTeamId();
  if (!teamId) {
    return undefined;
  }

  return `${name}-${teamId}`;
};
